import { DeprecatedPhoneCountryCodeInput } from "common/form/inputs/phone/country_code";
import { DeprecatedFieldWrapper } from "common/form/enhancers/redux_form_field_wrapper";

/** @deprecated - please use components in common/core/form */
export const DeprecatedPhoneCountryCodeField = DeprecatedFieldWrapper(
  DeprecatedPhoneCountryCodeInput,
);
